// Estilos de dispositivos para la app PWA
// Basado en deviceStyles.ts de la app WEB

// Mapa de imágenes de dispositivos (archivos locales de la PWA)
export const deviceTypeImages: { [key: string]: string } = {
  'DIMMER2': require('../assets/images/DIMMER2.png'),
  'EM3': require('../assets/images/EM3.png'),
  'EM': require('../assets/images/EM.png'),
  'PLUS1PM': require('../assets/images/PLUS1PM.png'),
  'PLUS1': require('../assets/images/PLUS1.png'),
  'PLUS2PM': require('../assets/images/PLUS2PM.png'),
  'PRO1PM': require('../assets/images/PRO1PM.png'),
  'PROEM50': require('../assets/images/PROEM50.png'),
  'PRO3EM63': require('../assets/images/PROEM50.png'),
};

// Imagen por defecto
export const defaultImage = require('../assets/images/DIMMER2.png');

// Función para obtener el color según el consumo
export const getColorForConsumo = (consumo?: number): string => {
  if (consumo === undefined || consumo === null) return '#888888';
  return consumo >= 0 ? '#2391FF' : '#00ff00';
};

// Función para formatear consumo (W o kW)
export const formatearConsumo = (watts: number): string => {
  if (Math.abs(watts) >= 1000) {
    return `${(watts / 1000).toFixed(2)} kW`;
  }
  return `${watts.toFixed(2)} W`;
};

// Constantes para botones de dispositivos
export const POWER_BUTTON_SIZE = 43; // Tamaño base del botón de poder
export const ANIMATION_DURATION = 0.3; // Duración de las animaciones en segundos

